import React, { useState } from "react";
import Login from "./Login";
import SignUp from "./signup";

const AuthModal = ({ initialMode = "login", onClose, onSuccess }) => {
  const [mode, setMode] = useState(initialMode); // 'login' or 'signup'

  const switchToSignUp = () => {
    setMode("signup");
  };

  const switchToLogin = () => {
    setMode("login");
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
    handleClose();
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <div style={tabStyles.container}>
          <button
            style={{
              ...tabStyles.tab,
              ...(mode === "login" ? tabStyles.activeTab : tabStyles.inactiveTab),
            }}
            onClick={() => setMode("login")}
          >
            Login
          </button>
          <button
            style={{
              ...tabStyles.tab,
              ...(mode === "signup" ? tabStyles.activeTab : tabStyles.inactiveTab),
            }}
            onClick={() => setMode("signup")}
          >
            Sign Up
          </button>
        </div>

        {mode === "login" ? (
          <Login
            switchToSignUp={switchToSignUp}
            onClose={handleClose}
            onSuccess={handleSuccess}
          />
        ) : (
          <SignUp
            onClose={handleClose}
            switchToLogin={switchToLogin}
            onSuccess={handleSuccess}
          />
        )}
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: "20px",
  },
  modalContent: {
    position: "relative",
    maxWidth: "520px",
    width: "100%",
    maxHeight: "95vh",
    overflowY: "auto",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "rgba(255, 255, 255, 0.9)",
    border: "none",
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    fontSize: "20px",
    cursor: "pointer",
    zIndex: 1001,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const tabStyles = {
  container: {
    display: "flex",
    borderBottom: "2px solid #e0e0e0",
    marginBottom: 0,
  },
  tab: {
    flex: 1,
    padding: "14px 0",
    border: "none",
    background: "transparent",
    fontSize: "16px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s",
    outline: "none",
  },
  activeTab: {
    color: "#005487",
    borderBottom: "3px solid #005487",
    marginBottom: "-2px",
  },
  inactiveTab: {
    color: "#999",
  },
};

export default AuthModal;
